import { ImageGroupeByFolderModel } from './image.groupe.by.folder.model';

export class PagedImageGroupeByFolderDetails {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: ImageGroupeByFolderModel[] = [];
}
